<template>
  <div>
    <b-card>
      <div class="organism-idc-management_header card-padding">
        <span class="header__label">NTDC Database</span>
      </div>
      <div class="filter-container card-padding pt-0">
        <div class="row mt-0">
          <div class="col-12 col-lg-4">
            <atom-input
              title="ID/Passport Number"
              placeholder="ID/Passport Number"
              v-model="filterList.idOrPassportNumber"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-4 mt-1 mt-lg-0">
            <atom-multi-select
              title="Role"
              placeholder="All Role"
              v-model="filterList.role"
              label="name"
              :isEnableProper="false"
              :isAppendToBody="false"
              :option="roleOption"
            ></atom-multi-select>
          </div>
          <div class="col-12 col-lg-4 mt-1 mt-lg-0">
            <atom-select
              v-model="filterList.contactPoint"
              label="contactPointName"
              title="Contact Point Name"
              placeholder="Contact Point Name"
              :isEnableProper="false"
              :isAppendToBody="false"
              :option="contactPointNameOption"
            ></atom-select>
          </div>
          <div class="col-12 col-lg-4 mt-1">
            <atom-input
              title="Email"
              placeholder="Email"
              v-model="filterList.email"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-4 mt-1">
            <atom-input
              title="Phone"
              placeholder="Phone"
              v-model="filterList.phone"
              @onKeyupEnter="clickButtonSearch"
            ></atom-input>
          </div>
          <div class="col-12 col-lg-4 mt-1 d-flex align-items-center">
            <div class="mr-2 w-100">
              <atom-input
                v-model="filterList.idcId"
                :title="contractIdLabel"
                :placeholder="contractIdLabel"
                type="number"
                :maxLength="8"
                @onKeyupEnter="clickButtonSearch"
              ></atom-input>
            </div>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                class="search__button"
                @click="clickButtonSearch"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row card-padding">
        <div
          v-if="hasUpdateNtdcContactPointPermission"
          class="col-12 d-flex justify-content-end"
        >
          <atom-button
            buttonId="create-new-customer"
            class="header__button"
            buttonStyle="border"
            @click="goToCreateContact"
          >
            <template>Create New Contact Point</template>
          </atom-button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 table-wrapper">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="fields"
            :hover="true"
            @row-clicked="selectRow"
            show-empty
          >
            <template #cell(id)="data">
              <div class="header">{{ data.value }}</div>
            </template>
            <template #cell(email)="data">
              <div class="sub-header">{{ data.value.one }}</div>
              <div v-if="data.value.two" class="sub-header">
                {{ data.value.two }}
              </div>
              <div v-if="data.value.three" class="sub-header">
                {{ data.value.three }}
              </div>
            </template>
            <template #cell(phone)="data">
              <div class="sub-header">{{ data.value.one }}</div>
              <div v-if="data.value.two" class="sub-header">
                {{ data.value.two }}
              </div>
              <div v-if="data.value.three" class="sub-header">
                {{ data.value.three }}
              </div>
            </template>
            <template #empty>
              <div
                class="d-flex flex-column align-items-center justify-content-center my-4"
              >
                <feather-icon
                  icon="CloudOffIcon"
                  class="empty-data__icon"
                ></feather-icon>
                <label class="empty-data__text--title">No Data</label>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <molecule-pagination-with-per-page
        :page="filterList.currentPage"
        :total-count="filterList.totalCount"
        :per-page="filterList.perPage"
        @onUpdatePaginationOrPerPage="onUpdatePaginationOrPerPage"
      ></molecule-pagination-with-per-page>
    </b-card>
    <footer style="height: 1px"></footer>
  </div>
</template>

<script>
import { BCard, BTable, BPagination } from "bootstrap-vue"
import AtomMultiSelect from "@/components/atoms/AtomMultiSelect.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import MoleculePaginationWithPerPage from "@/components/molecules/MoleculePaginationWithPerPage.vue"
import mixins from "@/mixins"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismIdcCustomerManagement",
  components: {
    BCard,
    BTable,
    BPagination,
    AtomMultiSelect,
    AtomButton,
    AtomInput,
    AtomSelect,
    MoleculePaginationWithPerPage,
  },
  mixins: [mixins, mixinsUser],
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    roleOption: {
      required: true,
      type: Array,
    },
    contactPointNameOption: {
      required: true,
      type: Array,
    },
    fields: {
      type: Array,
      required: false,
      default: [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    hasUpdateNtdcContactPointPermission() {
      return this.hasPermission(PermissionUser.WPM.NTDC_CONTACT_POINT_WRITE)
    },
  },
  methods: {
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },

    clickButtonClearFilter() {
      this.$emit("onSetDefaultFilterData")
    },

    badgeVariant(status) {
      if (status === 1) return "light-info"
      else if (status === 2) return "light-success"
      else if (status === 3) return "light-danger"
      else if (status === 4) return "light-warning"
      else return "light-secondary"
    },
    badgeStatus(status) {
      if (status === 1) return "Pending"
      else if (status === 2) return "Approved"
      else if (status === 3) return "Deleted"
      else if (status === 4) return "Suspended"
      else return "Expired"
    },
    selectRow(record, index) {
      this.$emit("clickRow", record, index)
    },
    goToCreateContact() {
      this.$router.push(
        "/internal/web-portal/idc/contact-point-and-sale/create"
      )
    },

    onUpdatePaginationOrPerPage(currentPerPage, currentPage) {
      const updatedFilter = {
        ...this.filterList,
        currentPage,
        perPage: currentPerPage,
      }
      this.$emit("onUpdateCurrentPageOrPerPage", updatedFilter)
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper ::v-deep.b-table-sticky-header {
  min-height: 500px;
  max-height: calc(100vh - 625px);
  &:has(.b-table-empty-row) {
    min-height: 350px;
  }
}

.organism-idc-management_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.filter-container {
  border-bottom: 1px solid #e9ecef;
}
.header {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #6e6b7b;

  overflow-wrap: break-word;
  word-break: break-word;
}
.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #6e6b7b;
}

.card-body {
  padding: 0;
}

.card-padding {
  padding: 1.5rem;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
    color: #7367f0;
  }
}
</style>
